<template>
    <div v-bind:id="['blog_'+card]" class="blog-item" v-on:click="gotodetail">
        <div class="shadow rounded blog-item-inner" v-bind:class="onHover ? 'shadow-lg cursor-hand' : ''" v-b-hover="handleHover">
            <b-media>
                <template #aside>
                    <b-icon icon="file-earmark-text" font-scale="4" class="border border-secondary rounded p-2" variant="secondary" v-if="type == 1"></b-icon>
                    <b-icon icon="camera-video" font-scale="4" class="border border-secondary rounded p-2" variant="secondary" v-if="type == 2"></b-icon>
                </template>
                <h4 class="text-primary blog-title">{{title}}</h4>
                <p class="text-muted blog-time">{{timeDesc}}</p>
                <p class="text-muted blog-desc">{{desc}}</p>
                <p class="blog-cate">
                    <CategoryItem v-for="(item, index) in categoryNames" v-bind:key="index" v-bind:name="item" v-bind:onlyShow="true"/>
                </p>
            </b-media>
        </div>
    </div>
</template>


<script>

import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import  CategoryItem from './CategoryItem'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)


export default {
    name : 'BlogItem',
    props: {
        card: String,
        title: String,
        desc: String,
        timeDesc: String,
        categoryNames: Array,
        type: Number

    },
    data : function(){
        return {
            onHover : false
        }
    },
    components: {
        CategoryItem
    },
    mounted: function(){
        //console.log("categoryNames : " + this.categoryNames);
    },
    methods : {
        handleHover: function(hovered) {
            this.onHover = hovered
        },
        gotodetail : function(){
            window.location.href = '/blog/' + this.card;
        }
    }
}

</script>

<style scoped>
    .blog-item{
        padding-bottom: 20px;
    }
    .blog-item-inner{
        height: 200px;
        padding: 1em;
    }
    .blog-time{
        margin-top:15px;
        font-size: 0.75em;
    }
    .blog-desc{
        margin-top:30px;
    }
    .blog-cate{
        margin-top:30px;
    }
    .cursor-hand{
        cursor: pointer;
    }
</style>